export const FACEBOOK_LOGIN_ENABLED =
  (import.meta.env.VITE_FACEBOOK_LOGIN || "").toLowerCase() === "true";

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID || "";

// Sign in with Apple (required by App Store Guideline 4.8 because the app
// also offers Google/Microsoft sign-in). On native iOS the bundle ID is the
// audience; on web the Services ID is. APPLE_SERVICES_ID + APPLE_REDIRECT_URI
// are only needed for the web sign-in flow; native iOS works without them.
export const APPLE_SERVICES_ID = import.meta.env.VITE_APPLE_SERVICES_ID || "";
export const APPLE_REDIRECT_URI =
  import.meta.env.VITE_APPLE_REDIRECT_URI || "";
export const APPLE_NATIVE_CLIENT_ID =
  import.meta.env.VITE_APPLE_NATIVE_CLIENT_ID || "com.siftcareers.app";

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || "",
    authority:
      import.meta.env.VITE_MICROSOFT_AUTHORITY ||
      "https://login.microsoftonline.com/common",
    redirectUri:
      import.meta.env.VITE_MICROSOFT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const microsoftLoginRequest = {
  scopes: ["User.Read"],
};
